import { useEffect, useRef, useState } from 'react';
import BgNsCaveat from '@britishgasenergy/react-nucleus/dist/nuc-components/NsCaveat';

import { useScreen } from 'hooks/useScreen';

type NsCaveatProps = {
  type?: 'standard' | 'alert' | undefined;
  children?: React.ReactNode;
  heading?: string;
  testId?: string;
};

export const NsCaveat = ({
  type = 'standard',
  children,
  heading,
  testId
}: NsCaveatProps) => {
  const { setCaveatRef, caveatItemIdsRef } = useScreen();
  const caveatRef = useRef(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    setCaveatRef(caveatRef?.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caveatRef]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // watch for changes in registered caveat links
    setHidden(!caveatItemIdsRef.current?.length && !children);
  });

  // use hidden attribute for NsCaveatLink to create the react portal
  const hiddenProp = hidden ? { hidden } : {};

  return (
    <BgNsCaveat data-testid={testId} type={type} {...hiddenProp}>
      {heading && <h2 slot="heading">{heading}</h2>}
      <div slot="caveat">
        {children}
        <ol ref={caveatRef}></ol>
      </div>
    </BgNsCaveat>
  );
};
